module.exports = __webpack_public_path__ + "img/stageSection03.7ea3ded7.png";